export default __webpack_public_path__ + "static/media/logoHorizontal.c6c1186c.png";